import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { adminService } from '@/services/adminService';
import { ROUTES } from '@/utils/appConstants';

/**
 * Guard component that checks if the landing page is active.
 * If not, it redirects to the home page.
 */
function LandingPageGuard({ children }) {
  const [isActive, setIsActive] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function checkStatus() {
      try {
        const response = await adminService.getPublicSettings();
        if (response.success) {
          setIsActive(response.data.isLandingPageActive);
        } else {
          setIsActive(false);
        }
      } catch (error) {
        setIsActive(false);
      } finally {
        setLoading(false);
      }
    }
    checkStatus();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  if (isActive === false) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return children;
}

export default LandingPageGuard;
